/**
 * WARNING: Class names may be obfuscated in production builds.
 * Use @ClassName decorator to define a custom name that can be fetched in production using getClassName.
 * For models, the class name will be set via @ModelId decorator.
 */
import { isPrimitive } from '../utils';
const nameStorage = new Map();
export function ClassName(name) {
  return function (cls) {
    nameStorage.set(cls, name);
  };
}
export function getClassName(ctorOrInstance, metaOnly = false) {
  if (isPrimitive(ctorOrInstance)) throw new Error('getClassName with argument ctorOrInstance being a primitive. Only use getClassName with classes/instances!');
  const ctor = typeof ctorOrInstance === 'function' ? ctorOrInstance : ctorOrInstance?.constructor;
  if (nameStorage.has(ctor)) return nameStorage.get(ctor);
  if (metaOnly) return undefined;
  return ctor?.name || undefined;
}
export function findModelByClassName(name) {
  const match = Array.from(nameStorage.entries()).find(([ctor, mname]) => {
    return name === mname;
  });
  if (!match) throw new Error('findModelByClassName failed: no model with name "' + name + '" has been registered!');
  return match[0];
}